import {BaseDomainModel} from "../../../../../infrastructure/models/base-domain-model";
import {GameStatsActualPlayTimeApiModel} from "./game-stats.actual-play-time.api-model";
import {GameStatsActualPlayTimeProgressDomainModel} from "./progress/game-stats.actual-play-time.progress.domain-model";
export class GameStatsActualPlayTimeDomainModel extends BaseDomainModel {
  apiModel: GameStatsActualPlayTimeApiModel

  constructor(model: GameStatsActualPlayTimeApiModel) {
    super(model)

    this.title = model.title;
    this.actualTime = model.actualTime ? new GameStatsActualPlayTimeProgressDomainModel(model.actualTime) : null;
    this.totalTime = model.totalTime ? new GameStatsActualPlayTimeProgressDomainModel(model.totalTime) : null;
  }

  get actualProgress() {
    return Math.min(this.actualTime.progress, 1)
  }

  get totalProgress() {
    return Math.min(this.totalTime.progress, 1)
  }
}
